/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useEffect, useRef } from "react";

/**
 * Execute a useEffect callback only once
 * @param {function} callback
 * @param {Array} deps
 */
export const useEffectOnce = (callback, deps) => {
	const calledOnce = useRef(false);

	useEffect(() => {
		if (calledOnce.current) {
			return;
		}

		callback(deps);
		calledOnce.current = true;
	}, [callback, deps]);
};
